/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import { clearOldSession, loginUserViaSessionData } from './_shared';

const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT;
const IDP_SESSION_CALL_TIMEOUT = 20000; // 20 seconds
const currentRoot = window.location.origin;

const urlParams = new URLSearchParams(window.location.search);

// Route builders
const API_ROUTES = {
  identityProviderSessions: idpName => `${API_BASE_URL}/auth/sso/idps/${idpName}/sessions`,
};
const FRONT_END_ROUTES = {
  ssoLoginUrl: idpName => `${currentRoot}/${idpName}/auth/sso/login`,
};

// Variable
const config = {};

// Api request cancellation
let __abortController;
const cancelCurrentRequest = function cancelCurrentRequestFn() {
  if (__abortController) {
    __abortController.abort();
  }
};

// Config and init
const init = async function initFn(idpName) {
  Object.assign(config, {
    name: idpName,
  });
  return true;
};

// Login with code from IDP
const tryLoginWithIdpCode = async function tryLoginWithIdpCodeFn() {
  const errorParam = urlParams.get('error');
  if (errorParam) {
    const err = new Error(errorParam);
    err.response = { data: { details: errorParam } };
    throw err;
  }

  const otpToken = urlParams.get('otpToken');
  if (!otpToken) {
    throw new Error('OTP parameter is required!');
  }

  const { session, username, meta } = await __createSessionFromParameters({ otpToken });

  return { session, username, redirectToPath: meta.redirectToPath };
};

const __createSessionFromParameters = async function __createSessionFromParametersFn(parameters = {}) {
  await clearOldSession();

  const { data: loggedInData } = await axios.post(API_ROUTES.identityProviderSessions(config.name), {
    ...parameters,
    redirectUrl: FRONT_END_ROUTES.ssoLoginUrl(config.name),
  }, { timeout: IDP_SESSION_CALL_TIMEOUT });

  await loginUserViaSessionData(loggedInData);

  return loggedInData;
};

const moduleExports = {
  init,
  tryLoginWithIdpCode,
  cancelCurrentRequest,
};

export default moduleExports;
